<div [ngClass]="this.menuService.menuOptions['user'] ? 'active' : ''" class="database-menu">
  <div>
    <h1>User ({{gritUserService.displayName || gritUserService.username}})</h1>
    <ul>
      <h4>Groups</h4>
      <div style="overflow-y: scroll; max-height:50px; text-wrap: pretty">
        <p *ngFor="let group of gritUserService.groupsPaths">{{group}}</p>
      </div>

      <ng-container *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)">
        <h4>Test Entities</h4>
        <app-menu-option
          [action]="this.tabsService.gritOpenUniqueTab.bind(tabsService, TabsService.MANAGE_DEVICES)"
          [labelOnMenu]="'RFI-Transmitter'"
          [label]="'RFI-Transmitter'">
        </app-menu-option>
        <app-menu-option
          [action]="this.tabsService.gritOpenUniqueTab.bind(tabsService, TabsService.MANAGE_RECEIVERS)"
          [labelOnMenu]="'Receivers'"
          [label]="'Receivers'">
        </app-menu-option>
      </ng-container>

        <h4>Actions</h4>
        <app-menu-option
          [action]="openSubscriptionList.bind(this)"
          [labelOnMenu]="'Subscriptions'"
          [label]="'Subscriptions'">
        </app-menu-option>

      <app-menu-option *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)"
          [action]="openMailingList.bind(this)"
          [labelOnMenu]="'Mailing List'"
          [label]="'Mailing List'">
        </app-menu-option>

      <h4>Help</h4>
      <app-menu-option
        [action]="this.openGRITXwiki.bind(this)"
        [labelOnMenu]="'User Manual'"
        [label]="'User Manual'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openGRITXwikiFAQ.bind(this)"
        [labelOnMenu]="'Frequently Asked Questions (FAQ)'"
        [label]="'Frequently Asked Questions'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openReadMeModal.bind(this)"
        [labelOnMenu]="'Read Me'"
        [label]="'Read Me'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openAboutGritModal.bind(this)"
        [labelOnMenu]="'About Grit'"
        [label]="'About Grit'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openSelfTrainingToolModal.bind(this)"
        [labelOnMenu]="'Self-Training Tool'"
        [label]="'Self-Training Tool'">
      </app-menu-option>
      <app-menu-option *ngIf="gritUserService.isAdmin$ | async"
        [action]="this.openErrorLogs.bind(this)"
        [labelOnMenu]="'Inspect Error Logs'"
        [label]="'Inspect Error Logs'">
      </app-menu-option>
      <h4>Support Center</h4>
      <app-menu-option *ngIf="preReleaseToolEnabled"
        [action]="this.openNewTicket.bind(this)"
        [labelOnMenu]="'Open New Ticket'"
        [label]="'Open New Ticket'">
      </app-menu-option>

      <app-menu-option *ngIf="preReleaseToolEnabled"
        [action]="this.openMyTickets.bind(this)"
        [labelOnMenu]="'Support Tickets'"
        [label]="'Support Tickets'">
      </app-menu-option>

      <h4>User Information</h4>

      <app-menu-option
        [action]="this.openUserProfile.bind(this)"
        [label]="'User Profile'">
      </app-menu-option>


      <app-menu-option
        [action]="this.openUserSpaceUser.bind(this)"
        [label]="'User Space'">
      </app-menu-option>


      <h4>Session</h4>
      <app-menu-option
        [action]="this.confirmLogout.bind(this)"
        [labelOnMenu]="'Logout'"
        [label]="'Logout'">
      </app-menu-option>
    </ul>
  </div>
</div>
